import axios from '~/common/plugins/axios.js'
export const state = () => ({
    data: [],
    pagination: {
        listName: "询价子项",
        total: 0,
        current: 1,
        page_size: 50,
    },
    options:[],
    operateData:[],
    operateIndex: -1,
})

export const mutations = {
    setData(state, data) {
        state.data = data
    },
    setDataCount(state, data) {
        state.pagination.total = data
    },
    setOperateData(state, data) {
        state.operateData = data
    },
    setOperateIndex(state, data) {
        state.operateIndex = data
    },
    setDecimal(state, data) {
        state.decimal = data
    },
    setPagination(state, data) {
        state.pagination.current = data
    },
    setOptions(state, data) {
        state.options = data
    },
}

export const actions = {
    async add({commit}, {parameter}) {
        const data = await axios.$post("/rest/store/biz/v3/rfqline/multicreate", {...parameter});
        return data;
    },
    updateOperateData({commit}, {parameter}){
        commit('setOperateData', parameter)
    },
    updatePagination({commit}, {parameter}){
        commit('setPagination', parameter)
    },
    updateOptions({commit}, {parameter}){
        commit('setOptions', parameter)
    },
    updateOperateIndex({commit}, {parameter}){
        commit('setOperateIndex', parameter)
    },
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
